import { useEffect, useState } from "react";
import "./NewProject.css"
import { useNavigate } from "react-router-dom";
import { projectEndpoint } from "../../../variables/services";
import { getUser } from "../../../scripts/auth";
import { authFecth } from "../../../scripts/requests";


function NewProject({ mode, exit, project }) {
    const navigate = useNavigate();
    const [name, setName] = useState("")
    
    
    async function submit(e) {
        e.preventDefault();
        let args={};
        const user = await getUser();
        const body = {project: {name: name, account_id: user.account_id}}
        if (mode === "edit") {
            args.project_id = project.id
        }
            await authFecth(projectEndpoint + "/project", mode === "create" ? "POST" : "PUT", args, body)
            .then(res => {
              if (!res.ok) { 
                return res.json().then(data => {
                  alert("Error creating project:" + data.message)
                  throw new Error("Error: " + (data.message || "Unknown error")); // Handle API error messages
                });
              }
              return res.json();
            })
            .then(data => {
            })
            .catch(error => {
              console.error("Error creating project:", error);
            });
        exit()
    }
    

    useEffect (()=>{
        setName(project.name)
    }, [])
    return (
        <form className="new-project-form shadow-glow ">
            <h3>{mode === "create" ? "New Project": "Rename"}</h3>
            <div className="project-info">
              <label className="new-project-form-label">name:</label>
              <input className="new-project-form-input" value={name} onChange={(e) => {setName(e.target.value)}} type="text"/>
            </div>
            <div className="buttons">
              <button className="submit" onClick={submit}>{mode === "create" ? "create" : "save"}</button>
              <button className="cancel" onClick={exit}>cancel</button>
            </div>
        </form>

    );
  }
  
export default NewProject;